import React from "react";
import "./Skeleton.css";

/**
 * Shimmering placeholder block. Compose these (plus SkeletonCircle/SkeletonText)
 * to build a skeleton that mirrors the real content's layout.
 */
export const Skeleton = ({ width = "100%", height = 16, radius = 6, style, className = "" }) => (
  <div
    className={`sp-skeleton ${className}`}
    style={{ width, height, borderRadius: radius, ...style }}
  />
);

export const SkeletonCircle = ({ size = 40, style, className = "" }) => (
  <Skeleton width={size} height={size} radius="50%" style={style} className={className} />
);

export const SkeletonText = ({ lines = 1, lastLineWidth = "60%", gap = 8, style }) => (
  <div style={{ display: "flex", flexDirection: "column", gap, ...style }}>
    {Array.from({ length: lines }).map((_, i) => (
      <Skeleton key={i} height={13} width={i === lines - 1 ? lastLineWidth : "100%"} />
    ))}
  </div>
);

export default Skeleton;
